import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { getLatestStories } from "../../../actions/latestStories";
import MiniStoryCard from "../MiniStoryCard";
import Spinner from "../Spinner";
import Ad from "components/Library/Ad";
import styles from "./LatestStories.css";

class LatestStories extends Component {
  componentDidMount() {
    if (!this.props.latestStories.results.length) {
      this.props.getLatestStories();
    }
  }

  renderPromo() {
    return (
      <div className={styles.promo}>
        <Ad adUnit="sidebar" slotSize={[300, 275]} />
      </div>
    );
  }

  render() {
    if (this.props.latestStories.results.length === 0) {
      if (this.props.latestStories.isLoading) {
        return <Spinner />;
      }
      return null;
    }

    const latestSorted = [...this.props.latestStories.results].sort(
      (a, b) =>
        a.published_date > b.published_date
          ? -1
          : a.published_date < b.published_date
            ? 1
            : 0
    );

    return (
      <div className={this.props.className}>
        <h2 className={classNames(styles.heading, styles.hiddenLarge)}>
          Latest Stories
        </h2>
        <div className={styles.root}>
          <h2 className={classNames(styles.heading, styles.hiddenSmall)}>
            Latest Stories
          </h2>
          {latestSorted.map((latest, i) => (
            <div key={latest.id}>
              <MiniStoryCard
                storyCardRef={
                  i === this.props.latestStories.results.length - 1
                    ? this.props.latestStoriesRef
                    : undefined
                }
                className={
                  i === this.props.latestStories.results.length - 1
                    ? "finalLatestStoriesItem"
                    : undefined
                }
                latest={latest}
              />
              {i === 4 && this.renderPromo()}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    latestStories: state.latestStories,
  };
};

export default connect(
  mapStateToProps,
  { getLatestStories }
)(LatestStories);
